import { yup } from "@swa-ui/object";

let schemas;

export function getAirSeatsMktgDataSchemas() {
  if (!schemas) {
    schemas = {
      confirmSeats: mktgConfirmationSeatsSchema(),
      purchaseSeats: mktgPurchaseSeatsSchema(),
      selectSeats: mktgSelectSeatsSchema(),
    };
  }

  return schemas;
}

function mktgSelectSeatsSchema() {
  return yup.object().shape({
    air_confirmationnumber: yup.string().optional(),
    air_triptype: yup.string().optional(),
    airport_codes: yup.string().optional(),
    bookingcurve: yup.string().optional(),
    bound_number: yup.string().optional(),
    extraseat: yup.string().optional(),
    familybooking: yup.string().optional(),
    informational_message: yup.string().optional(),
    informational_message_display: yup.string().optional(),
    lengthofflight: yup.string().optional(),
    number_passengers: yup.string().optional(),
    pax_number: yup.string().optional(),
    revenuestream: yup.string().optional(),
    rrchasecardholder: yup.string().optional(),
    rrchasecardtype: yup.string().optional(),
    seatsassigned: yup.string().optional(),
    seatsstandalone: yup.string().optional(),
    seatsupgrade: yup.string().optional(),
    seats_availableexit: yup.string().optional(),
    seats_availableexlegroom: yup.string().optional(),
    seats_availablepremium: yup.string().optional(),
    seats_availablestandard: yup.string().optional(),
    seats_total: yup.string().optional(),
    segments: yup.string().optional(),
    segment_number: yup.string().optional(),
    selectedfaretype: yup.string().optional(),
    standardseatsdisabled: yup.string().optional(),
    timetodeparture: yup.string().optional(),
  });
}

function mktgPurchaseSeatsSchema() {
  return yup.object().shape({
    air_bound1_airportcode: yup.string().optional(),
    air_bound1_date: yup.string().optional(),
    air_bound1_selectedfaretype: yup.string().optional(),
    air_bound2_airportcode: yup.string().optional(),
    air_bound2_date: yup.string().optional(),
    air_bound2_selectedfaretype: yup.string().optional(),
    air_confirmationnumber: yup.string().optional(),
    bookingcurve: yup.string().optional(),
    bound_seat: yup.string().optional(),
    number_passengers: yup.string().optional(),
    productarray: yup.array().optional(),
    revenuestream: yup.string().optional(),
    rrchasecardtype: yup.string().optional(),
    sccheckout: yup.string().optional(),
    seatcredit: yup.string().optional(),
    seatprice: yup.string().optional(),
    seatproduct: yup.string().optional(),
    seatsstandalone: yup.string().optional(),
    segments: yup.string().optional(),
    triptype: yup.string().optional(),
    timetodeparture: yup.string().optional(),
  });
}

function mktgConfirmationSeatsSchema() {
  return yup.object().shape({
    air_confirmationnumber: yup.string().optional(),
    airportCodes: yup.string().optional(),
    bound_seat: yup.string().optional(),
    changetype: yup.string().optional(),
    formofpayment: yup.string().optional(),
    number_passengers: yup.string().optional(),
    productarray: yup.array().optional(),
    purchase: yup.string().optional(),
    revenuestream: yup.string().optional(),
    rrchasecardtype: yup.string().optional(),
    seatcredit: yup.string().optional(),
    seatprice: yup.string().optional(),
    seatproduct: yup.string().optional(),
    seatselectionskip_count: yup.string().optional(),
    seatsstandalone: yup.string().optional(),
    segments: yup.string().optional(),
  });
}
